// Central exclusion logic for non-sellable inventory.
//
// Golf carts and trailers were removed from the public Paradise-Performance
// site per the owner. They still exist in the database (and admin tooling can
// still manage them), so every PUBLIC-facing surface must filter them out.
//
// Detection works two ways so mislabeled rows can't slip through:
//   1. by explicit vehicle_type ('golf-cart', 'trailer', 'boat')
//   2. by make / model heuristics (common golf-cart & trailer brands)
//
// Keep this in sync with the inline filter in src/pages/Inventory.jsx.

const GOLF_CART_MAKES = [
  'ezgo', 'e-z-go', 'club car', 'clubcar', 'yamaha', 'icon',
  'advanced ev', 'tomberlin', 'star ev', 'bintelli',
];

const TRAILER_INDICATORS = [
  'trailer', 'p&c', 'big tex', 'carry-on', 'load trail', 'pj trailer', 'diamond c',
];

const EXCLUDED_TYPES = ['golf-cart', 'golf_cart', 'golfcart', 'cart', 'trailer', 'trailers', 'boat'];

/**
 * Returns true if the vehicle is a golf cart, trailer, or boat and must NOT be
 * shown on the public site. Accepts either DB-shaped (vehicle_type) or
 * frontend-shaped (vehicleType) records.
 */
export const isExcludedFromPublic = (vehicle) => {
  if (!vehicle) return false;

  const vType = String(vehicle.vehicleType || vehicle.vehicle_type || '').toLowerCase();
  const make = String(vehicle.make || '').toLowerCase();
  const model = String(vehicle.model || '').toLowerCase();

  if (EXCLUDED_TYPES.includes(vType)) return true;

  const isGolfCartByMake =
    GOLF_CART_MAKES.some((gc) => make.includes(gc)) ||
    model.includes('golf') || model.includes('cart') ||
    model.includes('txt') || model.includes('rxv') || model.includes('drive2');

  const isTrailerByMake = TRAILER_INDICATORS.some((t) => make.includes(t) || model.includes(t));

  return isGolfCartByMake || isTrailerByMake;
};

/**
 * Filters a list of vehicles down to only those that may appear publicly.
 */
export const excludeNonPublicVehicles = (vehicles = []) =>
  (vehicles || []).filter((v) => !isExcludedFromPublic(v));
